import { render, staticRenderFns } from "./AssignRuleModal.vue?vue&type=template&id=0ef1b37a&"
import script from "./AssignRuleModal.vue?vue&type=script&lang=ts&"
export * from "./AssignRuleModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports